import { CALENDAR_GRID_LABEL_SEPARATOR } from '../../../../../constants/calendarGrid'
import { getCalendarRequestLabel } from '../../../Calendar.utils'

export function getCalendarTaskMoveStepLabel({ item, t }) {
  return item.stepIndex
    ? [
        t('Calendar.MoveTaskStepKey', {
          index: item.stepIndex,
          total: item.stepTotal,
        }),
        getCalendarRequestLabel(item.request),
      ].join(CALENDAR_GRID_LABEL_SEPARATOR)
    : getCalendarRequestLabel(item.request)
}
